import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import Viewall from './Viewall'
import { Box } from '@chakra-ui/react';

const View = () => {
    return (
        <div>
            <HeaderSection
                title="Income Voucher"
                breadcrumb={["Dashboard", "Voucher", "Income List"]}
            />
            <Box p={6}>

                <Viewall />
            </Box>
        </div>
    )
}

export default View